export function lineReplyPreviewText(value) {
  return String(value || '').replace(/\r\n?/g, '\n')
    .replace(/[\x00-\x08\x0b\x0c\x0e-\x1f\x7f]/g, '').trim().slice(0,120);
}
export function updateLineReplyFromEvent(item, payload, deleted) {
  if(Number(item.room_id)!==Number(payload.room_id) || !Number.isSafeInteger(Number(payload.message_id)) || Number(payload.message_id)<1)return item;
  let meta;
  try { const raw=item.metadata_json ?? item.metadata;meta=typeof raw==='string'?JSON.parse(raw):raw; } catch { return item; }
  if (meta?.source!=='LINE_LIVE' || meta.reply?.source!=='LINE' || Number(meta.reply.message_id)!==Number(payload.message_id)) return item;
  const next = deleted ? {...meta,reply_to_message_id:null,reply:{source:'LINE',message_id:null,unavailable:true,sender_display:'LINE 답장',body_preview:'원문을 확인할 수 없습니다.'}}
    : {...meta,reply:{...meta.reply,body_preview:lineReplyPreviewText(payload.body) || '내용 없음'}};
  return {...item,metadata_json:typeof item.metadata_json==='object' && item.metadata_json!==null?next:JSON.stringify(next)};
}
